import React from 'react'
import { Virtuoso, ItemContent } from 'react-virtuoso'

//Use to display placeholders if the user scrolls fast through the list.
const VELOCITY_ENTER = 500
const VELOCITY_EXIT = 10

// Set the increaseViewportBy property to artificially increase the viewport size,
// causing items to be rendered outside the viewport.
// The property causes the component to render more items than the necessary,
// but can help with slow loading content and do some caching for a better UX experience.
const INCREASE_VIEWPORT_BY_PIXELS = 250

export type VirtualScrollProps = {
    /**
     * A reference to virtuoso used to scroll the list to a specific item
     */
    virtuoso: any
    /**
     * Calculate the height of the list from which height of the view port
     */
    heightFromTop?: number
    /**
     * Subtract from the height elements that are above the list like tabs or search field
     */
    maxViewHeight: number
    /**
     * Array of objects which are the data items of the list
     */
    data: Array<any>
    /**
     * A visual template (jsx) of the items displayed in the list
     */
    itemContent: ItemContent<any, any>
}

export function VirtualScroll({
    virtuoso,
    maxViewHeight,
    heightFromTop = 0,
    data,
    itemContent
}: VirtualScrollProps) {
    return (
        <>
            <Virtuoso
                ref={virtuoso}
                style={{
                    height: `calc(${maxViewHeight}vh - ${heightFromTop}px)`,
                    width: '100%'
                }}
                //The total amount of items to be rendered.
                totalCount={data?.length}
                //The data items to be rendered. If data is set, the total count will be inferred from the length of the array.
                data={data}
                //Advanced customization of the elements rendered by the list.
                components={{
                    ScrollSeekPlaceholder: () => (
                        <div
                            style={{
                                height: `40px`,
                                padding: '8px',
                                overflow: 'hidden'
                            }}
                        >
                            <div
                                style={{
                                    background: '#DCDCDC',
                                    height: `12px`
                                }}
                            />
                        </div>
                    )
                }}
                //Artificially increase the viewport size
                increaseViewportBy={INCREASE_VIEWPORT_BY_PIXELS}
                scrollSeekConfiguration={{
                    //Callback to determine if the list should enter "scroll seek" mode.
                    enter: velocity => Math.abs(velocity) > VELOCITY_ENTER,
                    //Callback to determine if the list should enter "scroll seek" mode.
                    exit: velocity => {
                        return Math.abs(velocity) < VELOCITY_EXIT
                    }
                }}
                //Set the callback to specify the contents of the item.
                itemContent={itemContent}
            />
        </>
    )
}
